import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";

import TextArea from "antd/es/input/TextArea";

import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import styles from "../../../../assets/styles/styles";
import { BOM } from "../../../../services/definedMethod";
import { labelConfig, staticConfig } from "../../../customer/customer.config";

//OTHER IMPORTS

const InterestRateChart = (props) => {
  const {
    // onFinish,
    form,
    periodTypeOptions,
    conditionTypeOptions,
    attributeNameOptions,
    formData,
    interestRateTableSource,
    setInterestRateTableSource,
    chargesOptions,
    chargeTableSource,
    setChargeTableSource,
    genderOptions,
    clientTypeOptions,
    clientClassificationOptions,
    isPrimaryGroupingByAmount,
    setIsPrimaryGroupingByAmnt,
    userData,
  } = props;

  const { session } = userData;
  const [chargeList, setChargeList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [periodTypeLabel, setPeriodTypeLabel] = useState();
  const dateFormat = "YYYY/MM/DD";

  const showValue = (value, option) => {
    setPeriodTypeLabel(option?.label);
  };

  const firstElement = (
    <Col span={8} style={{ padding: "0px 8px" }}>
      <Form.Item
        name="periodType"
        label="Period Type"
        rules={[
          {
            required: true,
            message: BOM.CheckReqFld(labelConfig.periodType),
          },
        ]}
      >
        <Select
          placeholder={"Please select a value"}
          options={periodTypeOptions}
          onChange={showValue}
          showSearch
        />
      </Form.Item>
    </Col>
  );
  const secondElement = (
    <>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item name="amountRangeFrom" label="Amount Range From">
          <InputNumber
            style={{ width: "100%" }}
            formatter={BOM.FormatAmount}
            parser={BOM.ParseAmount}
            placeholder="50,000"
            className="of-bold-disable-input"
          />
        </Form.Item>
      </Col>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item name="amountRangeTo" label="Amount Range To">
          <InputNumber
            style={{ width: "100%" }}
            formatter={BOM.FormatAmount}
            parser={BOM.ParseAmount}
            placeholder="50,000"
            className="of-bold-disable-input"
          />
        </Form.Item>
      </Col>
    </>
  );

  const [first, setFirst] = useState([]);
  const [second, setSecond] = useState([]);

  useEffect(() => {
    setFirst(firstElement);
    setSecond(secondElement);
  }, [periodTypeOptions]);

  const defaultColumns = [
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From",
      dataIndex: "fromPeriod",
    },
    {
      title: "Period To",
      dataIndex: "toPeriod",
    },
    {
      title: "Amount Range From",
      dataIndex: "amountRangeFrom",
    },
    {
      title: "Amount Range To",
      dataIndex: "amountRangeTo",
    },
    {
      title: "Interest",
      dataIndex: "annualInterestRate",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <DeleteInterestRate
            currentInterestRateObj={record}
            interestRateTableSource={interestRateTableSource}
            setInterestRateTableSource={setInterestRateTableSource}
          />
          &nbsp;
          <EditInterestRate
            interestRateTableSource={interestRateTableSource}
            setInterestRateTableSource={setInterestRateTableSource}
            periodTypeOptions={periodTypeOptions}
            currentInterestRateObj={record}
            userData={userData}
            transactionObj={record}
          />
        </>
      ),
    },
  ];
  const groupingByAmtColumns = [
    {
      title: "Amount Range From",
      dataIndex: "amountRangeFrom",
    },
    {
      title: "Amount Range To",
      dataIndex: "amountRangeTo",
    },
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From",
      dataIndex: "fromPeriod",
    },
    {
      title: "Period To",
      dataIndex: "toPeriod",
    },
    {
      title: "Interest",
      dataIndex: "annualInterestRate",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <DeleteInterestRate
            currentInterestRateObj={record}
            interestRateTableSource={interestRateTableSource}
            setInterestRateTableSource={setInterestRateTableSource}
          />
          &nbsp;
          <EditInterestRate
            interestRateTableSource={interestRateTableSource}
            setInterestRateTableSource={setInterestRateTableSource}
            periodTypeOptions={periodTypeOptions}
            currentInterestRateObj={record}
            userData={userData}
            transactionObj={record}
          />
        </>
      ),
    },
  ];

  const handleGrouping = (value) => {
    if (value) {
      setFirst(secondElement);
      setSecond(firstElement);
      setIsPrimaryGroupingByAmnt(true);
    } else {
      setSecond(secondElement);
      setFirst(firstElement);
      setIsPrimaryGroupingByAmnt(false);
    }
  };
  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  return (
    <div>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label="Valid Start Date"
            name="fromDate"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.fromDate),
              },
            ]}
          >
            <DatePicker
              disabledDate={disabledAfterCurrentDate}
              style={{ width: "100%", height: 32.5 }}
              format={dateFormat}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.fromDate, "select")}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label="End Date" name="endDate">
            <DatePicker
              style={{ width: "100%", height: 32.5 }}
              format={dateFormat}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.endDate, "select")}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="isPrimaryGroupingByAmount" label={labelConfig.isPrimaryGroupingByAmount}>
            <Select
              placeholder={"Please select a value"}
              options={staticConfig.yesOrNo}
              onChange={handleGrouping}
            />
          </Form.Item>
        </Col>
      </Row>
      <InterestRateModal
        formData={formData}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        chargeData={chargesOptions}
        setChargeList={setChargeList}
        setChargeTableSource={setChargeTableSource}
        chargeTableSource={chargeTableSource}
        chargeList={chargeList}
        session={session}
        periodTypeLabel={periodTypeLabel}
        first={first}
        second={second}
        attributeNameOptions={attributeNameOptions}
        incentiveTypeOptions={attributeNameOptions}
        genderOptions={genderOptions}
        clientTypeOptions={clientTypeOptions}
        clientClassificationOptions={clientClassificationOptions}
        periodTypeOptions={periodTypeOptions}
        conditionTypeOptions={conditionTypeOptions}
        userData={userData}
        interestRateTableSource={interestRateTableSource}
        setInterestRateTableSource={setInterestRateTableSource}
      />

      {interestRateTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0" />
          <Table
            columns={isPrimaryGroupingByAmount ? groupingByAmtColumns : defaultColumns}
            dataSource={interestRateTableSource}
            rowKey="id"
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </div>
  );
};

export default InterestRateChart;

const InterestRateModal = (props) => {
  const {
    isModalOpen,
    interestRateTableSource,
    setInterestRateTableSource,
    setIsModalOpen,
    periodTypeOptions,
    first,
    second,
    periodTypeLabel,
  } = props;
  const [useForm] = Form.useForm();
  //   console.log(periodTypeOptions);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleInterestRateSave = (formValues, productParam) => {
    const tempPeriodType = periodTypeOptions?.find((item) => item.value === formValues.periodType);
    // console.log(formValues);

    const newInterestRates = {
      key: BOM.GenerateTimestamp(),
      id: Number(BOM.GenerateTimestamp()),
      fromDate: BOM.DateTime(formValues.fromDate, "only-date"),
      endDate: BOM.DateTime(formValues.endDate, "only-date"),
      periodType: periodTypeLabel,
      fromPeriod:
        formValues?.fromPeriod !== undefined && formValues?.fromPeriod !== null
          ? formValues.fromPeriod
          : undefined,
      toPeriod:
        formValues?.toPeriod !== undefined && formValues?.toPeriod !== null
          ? formValues.toPeriod
          : undefined,
      amountRangeFrom:
        formValues?.amountRangeFrom !== undefined && formValues?.amountRangeFrom !== null
          ? formValues?.amountRangeFrom.toLocaleString()
          : undefined,
      amountRangeTo:
        formValues?.amountRangeTo !== undefined && formValues?.amountRangeTo !== null
          ? formValues?.amountRangeTo.toLocaleString()
          : undefined,
      annualInterestRate: formValues.annualInterestRate,
      description: formValues.description,
    };

    console.log("newInterestRates", newInterestRates);
    setInterestRateTableSource([...interestRateTableSource, newInterestRates]);
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addInterestRateChart}
      </Button>

      <Modal
        title="Interest Rate Chart"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleInterestRateSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Divider />
        <Row>
          {first}
          {second}
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="fromPeriod" label="Period From">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="toPeriod" label="Period To">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="annualInterestRate"
              label="Interest"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.interest),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="description" label="Description">
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Modal>
    </Row>
  );
};

const EditInterestRate = (props) => {
  const {
    currentInterestRateObj,
    periodTypeOptions,
    interestRateTableSource,
    setInterestRateTableSource,
  } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    const periodTypeValue = periodTypeOptions.find(
      (item) => item.label === currentInterestRateObj?.periodType
    )?.value;

    useForm.setFieldsValue({
      periodType: periodTypeValue,
      fromPeriod: currentInterestRateObj?.fromPeriod,
      toPeriod: currentInterestRateObj?.toPeriod,
      amountRangeFrom: currentInterestRateObj?.amountRangeFrom,
      amountRangeTo: currentInterestRateObj?.amountRangeTo,
      annualInterestRate: currentInterestRateObj?.annualInterestRate,
      description: currentInterestRateObj?.description,
    });
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (values) => {
    let periodTypeLabel;

    if (typeof values.periodType === "number") {
      periodTypeLabel = periodTypeOptions.find((item) => item.value === values.periodType)?.label;
    } else {
      periodTypeLabel = values.periodType;
    }
    const updatedValues = {
      ...values,
      periodType: periodTypeLabel,
      id: currentInterestRateObj?.id,
    };
    const editedIntRate = interestRateTableSource.map((item) =>
      item.id === updatedValues.id ? { ...item, ...updatedValues } : item
    );

    setInterestRateTableSource(editedIntRate);
    setIsModalOpen(false);
    useForm.resetFields();
  };

  return (
    <>
      <Tooltip title={`Edit`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Interest Rate"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="periodType"
              label="Period Type"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.periodType),
                },
              ]}
            >
              <Select
                placeholder={"Please select a value"}
                options={periodTypeOptions}
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="fromPeriod" label="Period From">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="toPeriod" label="Period To">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="amountRangeFrom" label="Amount Range From">
              <InputNumber
                style={{ width: "100%" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
                placeholder="50,000"
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="amountRangeTo" label="Amount Range To">
              <InputNumber
                style={{ width: "100%" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
                placeholder="50,000"
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="annualInterestRate"
              label="Interest"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.interest),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item name="description" label="Description">
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

const DeleteInterestRate = (props) => {
  const { interestRateTableSource, setInterestRateTableSource, currentInterestRateObj } = props;

  const handleInterestRateDelete = (key) => {
    console.log(key);

    let action = "Delete  ";
    let label = BOM.SubstringFormat("Interest Rate", 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = interestRateTableSource.filter((item) => item.id !== key.id);
        setInterestRateTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  return (
    <>
      {interestRateTableSource.length >= 1 ? (
        <Tooltip title={`Remove Interest Rate`}>
          <Button
            type="primary"
            icon={<DeleteOutlined />}
            onClick={() => handleInterestRateDelete(currentInterestRateObj)}
            shape="round"
            size="small"
            className="of-primaryBtnColor"
          />
        </Tooltip>
      ) : null}
    </>
  );
};
